<template lang="pug">
  .notification
    strong Pg:&nbsp
    | {{ carga.pg }}
    br
    strong Fin Carga:&nbsp
    | {{ carga.finCarga }}
    br
    strong Volumen (20°C):&nbsp
    | {{ carga.volumen20 }}
    br
    strong Masa:&nbsp
    | {{ parseInt(carga.masaKgs) }}
    br
    strong Presión:&nbsp
    | {{ carga.presion }}
    br
    strong Densidad (20°C):&nbsp
    | {{ carga.densidad20 }}
    br
    strong LLenadera:&nbsp
    | {{ carga.llenadera }}
    br
    strong Contenido en Litros:&nbsp
    | {{ Math.round(contenidoLitros) }}
    br
</template>

<script>
  export default {
    name: 'CardDatosCC_Edit',
    props: {
      carga: {
        type: Object,
        default: {}
      },
      valorUnitario: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        contenidoLitros: 0,
        cargaTotal: 0
      }
    },
    watch: {
      carga() {
        this.getCargaTotal()  
      }
    },
    methods: {
      getCargaTotal() {
        this.contenidoLitros = parseFloat(42 * 3.785412 * parseFloat(this.carga.volumen20))
        this.cargaTotal = parseFloat(this.valorUnitario * this.contenidoLitros).toFixed(2)
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/CardDatosCC_Edit.vue